/**
 * Customize to adjust styles on kit widget
 */

import { SxProps, Theme } from '@mui/material';

export const productDetailsContainerSX: SxProps<Theme> = {
	p: { xs: '10px', md: '20px' },
	m: 0,
};
